(function($) {

  // depandacies : 
  // - Scrolltrigger

  var 
    $HeadRoom = $('#HeadRoom'),
    progress = '0.00', 
    direction = 0;

  function init() {
    ScrollTrigger.create({
      trigger: "body",
      start: "top top",
      end: 'bottom bottom',
      onUpdate: function(self) {

        if (document.documentElement.classList.contains('no-scroll')) return;

        progress = self.progress.toFixed(2);
        direction = self.direction;

        var newClassName;

        if ( progress === '0.00' ) {
          newClassName = 'headroom-header headroom-header--top';
        } else if ( progress === '1.00' ) {
          newClassName = 'headroom-header headroom-header--notTop headroom-header--bottom';
        } else {
          newClassName = 'headroom-header headroom-header--notTop';

          if ( direction === 1 ) {
            newClassName += ' headroom-header--unpinned';
          }
        }
        $HeadRoom.attr('class',newClassName)
      }
    });
  }

  if( $HeadRoom.length ) init();

})(jQuery);